import { ApiService } from "../../../config";

/** Cartão "Presença em IA": robôs que leram o mini-site e % de citação nas IAs. */
export type RoboDeIa = {
  bot: string;
  grupo: string;
  visitas: number;
  primeiraVisita: string | null;
  ultimaVisita: string | null;
  leuLlms: boolean;
  primeiraLeituraLlms: string | null;
};

export type SemanaDeVisitas = {
  semana: string;
  visitas: number;
  robos: number;
  leiturasLlms: number;
};

/**
 * perguntas/citou/recomendou: só as perguntas de descoberta (sem o nome do negócio).
 * citou = nome, telefone ou site no texto OU nas fontes; recomendou = o negócio indicado no texto.
 * A pergunta pelo nome fica à parte (marcaPerguntas/marcaCitou): diz se a IA conhece o negócio.
 */
export type CitacaoPorMotor = {
  motor: string;
  semana: string;
  perguntas: number;
  citou: number;
  percentual: number;
  erros: number;
  recomendou: number;
  percentualRecomendou: number;
  marcaPerguntas: number;
  marcaCitou: number;
};

export type RespostaDaIa = {
  motor: string;
  semana: string;
  pergunta: string;
  citou: boolean;
  como: string | null;
  posicao: number | null;
  trecho: string | null;
  fontes: Array<{ url: string; titulo: string | null }>;
  /** Pergunta pelo nome do negócio ("telefone de NOME"). */
  marca: boolean;
  recomendou: boolean;
};

export type PresencaIa = {
  robos: RoboDeIa[];
  porSemana: SemanaDeVisitas[];
  citacoes: CitacaoPorMotor[];
  /** Só os números do grupo de controle: nunca o nome (é perfil de outro cliente). */
  controle: { citacoes: CitacaoPorMotor[] } | null;
  ultimas: RespostaDaIa[];
  /** Medição semanal ligada para este perfil. */
  ligado: boolean;
  /** Perfil marcado com o produto Presença em IA. */
  produto: boolean;
};

type Envelope<T> = { message?: string; error?: boolean; data?: T };

const unwrap = <T>(response: { data?: Envelope<T> }): T => {
  const body = response?.data;
  if (!body || body.error) {
    throw new Error(body?.message || "Não foi possível carregar a Presença em IA.");
  }
  return body.data as T;
};

export const presencaIaApi = {
  async consultar(profileId: string): Promise<PresencaIa> {
    return unwrap(await ApiService.get(`/business-profiles/${profileId}/presenca-ia`));
  },
};
